import * as React from "react"
import {createRoot} from "react-dom/client"
import { Route, Routes } from "react-router"
import {  HashRouter } from "react-router-dom"
import { AppContextWrapper } from "./appcontext"
import { SiteHome } from "./sitehome"

import "./tailwind.css"

function Main() {

    return <AppContextWrapper>
        <HashRouter >
            <Routes>
            <Route path="/*" element={<SiteHome />} />
            </Routes>   
        </HashRouter>
    </AppContextWrapper>

}

createRoot(document.getElementById('root')).render(<Main />)


